"use client";

import { useCallback, useRef, Suspense } from "react";
import type { CacheHandle } from "@/lib";
import type { MonitorOrdersDTO } from "@/data";
import { useActionPoll } from "@/lib";

interface Props {
    pollOrdersAction?: () => Promise<MonitorOrdersDTO>;
}

const Monitor = ({ pollOrdersAction }: Readonly<Props>) => {
    const pollOrders = useCallback(async () => {
        return await pollOrdersAction?.();
    }, [pollOrdersAction]);

    const pollRef = useRef<CacheHandle>(null);
    const [orders] = useActionPoll(pollRef, pollOrders);

    // FIXME use a table
    return <section>
        <h1>Monitor</h1>
        <Suspense>
        <table>
        <thead>
        <tr>
        <th scope="col">Order</th>
        <th scope="col">Status</th>
        <th scope="col">Customer</th>
        <th scope="col">Server</th>
        <th scope="col">Items</th>
        </tr>
        </thead>
        <tbody>
        {
            (orders ?? []).map(({ id, status, customerId, serverId, order }) =>
                <tr key={id}>
                <th scope="row">{id}</th>
                <td>{status}</td>
                <td>{customerId}</td>
                <td>{serverId}</td>
                <td>
                <details>
                <summary>{order.length}</summary>
                <ul>
                {
                    order.map((id, ix) => <li key={ix}>{id}</li>)
                }
                </ul>
                </details>
                </td>
                </tr>
                )
        }
        </tbody>
        </table>
        </Suspense>
        </section>;
};

export default Monitor;
